import React from 'react';
import PropTypes from 'prop-types';

import HintPopover from '../hint-popover/hint-popover';
import GDSelectUserPopover from "./popover/popover";
import GDSelectUserValueMulti from "./value/select-user-value-multi";
import GDSelectUserValue from "./value/select-user-value";

import { Deferred } from 'simply-deferred';

export const CUSTOM_TYPE = 'custom';
export const NO_VALUE_TYPE = 'no-value';
export const USER_TYPE = 'user';
export const ADD_TYPE = 'add';

export default class GDSelectUser extends React.Component {
    static propTypes = {

        value: PropTypes.string,                // userId
        values: PropTypes.array,
        options: PropTypes.array.isRequired,    // array of user IDs
        additionalOptions: PropTypes.array,     // array of objects to add to options, first usage to add "Not assigned" option

        placeholder: PropTypes.string,          // If no value selected string we display
        disabled: PropTypes.bool,               // if disabled not clickabel
        className: PropTypes.string,            // external class name

        // styles
        underlined: PropTypes.oneOf(['on-hover', 'always', 'never']),  // if set will show border bottom for the value


        // Render options
        avatarSize: PropTypes.string,           // size of avatr used for renderValue default tiny
        renderValue: PropTypes.oneOf(['name', 'icon-name', 'icon', 'inline', 'form-icon-name', 'form', 'control', 'func']).isRequired, // render value view name
        renderValueFunc: PropTypes.func,        // func for external render function if passed used to render instead of default
        // width: PropTypes.string,                // i.e. 300px - use it when cannot do via CSS i.e.

        // Callbacks
        onTogglePopover: PropTypes.func,        // event when popover opens/closes
        onChange: PropTypes.func,               // invokes everytime value changes (even with props)
        onUserSelect: PropTypes.func,           // invokes when user selects a value

        deleteButton: PropTypes.bool,           // if true will show delete button to reset user to null

        // No user options
        canHaveNoValue: PropTypes.bool,         // if true we have support "no value" as a selector
        noValueLabel: PropTypes.string,         // Text that will appear for "no-value" option
        noValueValue: PropTypes.any,         // Text that will appear for "no-value" option

        // Add user options
        addUserLabel: PropTypes.string,         // if passed we'll show "add user" option
        addUserCallback: PropTypes.func,        // add user callback

        infoMessage: PropTypes.any,             // popover bottom info message

        onDisabledClick: PropTypes.func,        //if click while disabled is true

        // popover options
        popoverFitTargetWidth: PropTypes.bool,  // if true popover width matches selector (value) width
        popoverStyle: PropTypes.object,         // special styles to popover

        attachmentType: PropTypes.oneOf(['full', 'vertical', 'horizontal']),
        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string,
        popoverClass: PropTypes.string,         // if passed will add this class to popover

        multiselect: PropTypes.bool,            // allow to select multiple users

        // form - if passed component will act as form element
        form: PropTypes.object,
        name: PropTypes.string,

        // advanced options
        searchable: PropTypes.bool,                 // display quick serach input
        keyboardNavigation: PropTypes.bool,         // navigate with keyboard up down enter
        hint: PropTypes.string,                     // if passed display hint on the users selected element
    };

    static defaultProps = {
        value: null,
        values: [],
        placeholder: "Please select",
        options: [],
        multiselect: false,

        canHaveNoValue: false,

        noValueValue: null,

        avatarSize: 'tiny',

        disabled: false,

        attachmentType: "full",
        attachment: "top center",
        targetAttachment: "bottom center",
        targetOffset: "0 0",
        searchable: true,
        keyboardNavigation: true
    };

    constructor(props) {
        super(props);

        let value = null;
        let values = [];

        if (props.form) {
            if (props.multiselect) values = props.form.getValue(props.name);
            else value = props.form.getValue(props.name);
        } else {
            value = props.value;
            values = props.values;
        }

        this.state = {
            showPopover: false,
            value: value,
            values: values,
            searchString: null,
            currentCursorKey: null
        };

        if (this.props.form) this.props.form.registerFormComponent(this.props.name,this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.multiselect) {
            if (nextProps.form) {
                const formValue = nextProps.form.getValue(nextProps.name);
                if (formValue !== this.state.values) this.setState({values: formValue});
            } else {
                if (nextProps.values && nextProps.values !== this.state.values) this.setState({values: nextProps.values});
            }
        } else {
            // when form value changed and we re-render the whole thing
            if (nextProps.form) {
                const formValue = nextProps.form.getValue(nextProps.name);
                if (formValue !== this.state.value) this.setState({value: formValue});
            } else {
                if (typeof nextProps.value !== 'undefined' && nextProps.value !== this.state.value) {
                    this.setState({value: nextProps.value});
                }
            }
        }
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (this.props.multiselect) if (nextState.values !== this.state.values && this.props.onChange) this.props.onChange(nextState.values);
        else if (nextState.value !== this.state.value && this.props.onChange) this.props.onChange(nextState.value);
    }

    togglePopover = () => {
        if (!this.props.disabled) {
            const showPopover = !this.state.showPopover;
            this.setState({
                showPopover: showPopover
            },()=>{
                if (this.props.onTogglePopover) this.props.onTogglePopover(showPopover);
            });
        }
    };

    // close popover + set value
    hidePopover = (selectedOption=null) => {
        let searchString = null;
        let showPopoper = false;
        let currentCursorKey = null;
        let value = this.state.value;
        let values = this.state.values;
        const stateChanged = new Deferred();

        if (selectedOption) {
            switch (selectedOption.type) {
                case USER_TYPE:
                case CUSTOM_TYPE:
                    const userId = selectedOption.user.id;
                    if (this.props.multiselect) {
                        values = gd.utils.toggleArrayObject(values, userId, id=>id === userId);
                        searchString = this.state.searchString;
                        showPopoper = true;
                        currentCursorKey = this.state.currentCursorKey;
                    } else {
                        value = userId
                    }
                    break;

                case NO_VALUE_TYPE:
                    value = this.props.noValueValue;
                    values = [];
                    break;
            }
        }

        this.setState({
            searchString: searchString,
            showPopover: showPopoper,
            currentCursorKey: currentCursorKey,
            value: value,
            values: values,
        },()=>{
            stateChanged.resolve();
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
        });

        return stateChanged;
    };

    onChangeCursorKey = (newValue) => {
        this.setState({currentCursorKey: newValue});
    }

    onDeleteClick = () => {
        this.onOptionSelected({type:NO_VALUE_TYPE});

        if (this.props.noValueValue === this.state.value) this.props.onUserSelect(this.props.noValueValue);
    };

    // on userOption click (keyboard enter)
    onOptionSelected = (option) => {
        const oldValue = this.state.value;
        const stateChanged = this.hidePopover(option);

        const { form, onUserSelect } = this.props;
        if (!form && !onUserSelect) return;

        switch (option.type) {
            case USER_TYPE:
            case CUSTOM_TYPE:
                if (this.props.multiselect) {
                    stateChanged.done(() => {
                        form && form.onFormComponentValueChange(this.props.name, this.state.values);
                        onUserSelect && onUserSelect( this.state.values);
                    });
                } else {
                    const userId = option.user.id;
                    if (userId !== oldValue) {
                        form && form.onFormComponentValueChange(this.props.name, userId);
                        onUserSelect && onUserSelect(userId);
                    }
                }
                break;

            case NO_VALUE_TYPE:
                if (this.props.multiselect) {
                    form && form.onFormComponentValueChange(this.props.name, this.props.noValueValue);
                } else {
                    if (this.props.noValueValue !== oldValue) {
                        form && form.onFormComponentValueChange(this.props.name, this.props.noValueValue);
                        onUserSelect && onUserSelect(this.props.noValueValue);
                    }
                }
                break;

            case ADD_TYPE:
                onUserSelect && this.props.addUserCallback && this.props.addUserCallback();
                break;
        }
    };

    onAddUserClick = () => {
        this.hidePopover(); // yes add user should go first ...
        this.props.addUserCallback();
    };

    // search changed....
    onSearchChange = (newSearchString) => {
        this.setState({
            searchString: newSearchString
        });
    };

    onClick = () => {if (this.props.disabled && this.props.onDisabledClick) this.props.onDisabledClick()};

    renderValue = () => {return this.props.multiselect ?
        <GDSelectUserValueMulti {...this.props}
                                showPopover={this.state.showPopover}
                                values={this.state.values}
                                onTogglePopover={this.togglePopover}/> :
        <GDSelectUserValue {...this.props}
                           showPopover={this.state.showPopover}
                           value={this.state.value}
                           onTogglePopover={this.togglePopover}/>};

    render() {
        const classes = Classes('gd-select-user', this.props.className, "render-"+this.props.renderValue, {
            "is-disabled":          this.props.disabled,
            "underlined-on-hover":  (this.props.underlined === 'on-hover'),
            "underlined-always":    (this.props.underlined === 'always'),
            "open":                 this.state.showPopover,
            "with-delete":          this.props.deleteButton,
            "multi-select":         this.props.multiselect,
            "no-val":               !(this.state.value && this.state.value !== this.props.noValueValue)
        });

        return (
            <div className={classes} onClick={this.onClick}>
                {this.renderValue()}
                {this.props.deleteButton && <div className="i5-delete-circle-solid" onClick={this.onDeleteClick}/>}
                {this.props.hint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.hint}/>}
                {this.state.showPopover && <GDSelectUserPopover {...this.props}
                                                                value={this.state.value}
                                                                values={this.state.values}
                                                                searchString={this.state.searchString}
                                                                currentCursorKey={this.state.currentCursorKey}
                                                                onChangeCursorKey={this.onChangeCursorKey}
                                                                onOptionSelected={this.onOptionSelected}
                                                                onSearchChange={this.onSearchChange}
                                                                onAddUserClick={this.props.addUserCallback ? this.onAddUserClick : null}
                                                                onHidePopover={this.hidePopover}/>}
            </div>
        );
    }
}
